import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { SchedulingModal } from '../../../../SchedulingModal'
// import { useTranslateContext } from 'gatsby-plugin-translate'

import { useHeaderContext } from '../../../Hooks/headerStates'
import { pushToDataLayerOnModalOpenning } from '../../../../../utils/tag'
import MenuItem from './MenuItem'

import * as S from './styled'

const MenuContainer = () => {
  const data = useStaticQuery(graphql`
    query {
      Menu: allWordpressAltaThemeHeader {
        nodes {
          sidebars {
            widgets {
              value {
                name
                items {
                  title
                  url
                  wordpress_children {
                    title
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  const menuMobileCheck = useHeaderContext()
  const menuOpenState = menuMobileCheck.getMenuMobileOpenState()

  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)

  // const { language } = useTranslateContext()

  const menuData = data.Menu.nodes[0].sidebars[0].widgets[1].value.items
  // tradução
  // const menuData =
  //   language === 'pt-br'
  //     ? data.Menu.nodes[0].sidebars[0].widgets[1].value.items
  //     : data.MenuEn.nodes[0].sidebars[0].widgets[1].value.items

  const handleAgendarClick = e => {
    e.preventDefault()
    e.stopPropagation()
    setIsScheduleModalOpen(true)
    menuMobileCheck.setMenuMobileOpenState(false)
    pushToDataLayerOnModalOpenning({ buttonLabel: 'Agendar', origin: 'Menu Hamburger' })
  }

  const menuDataWithAgendar = [
    {
      title: 'Agendar',
      url: '#',
      wordpress_children: [],
      onClick: handleAgendarClick,
    },
    ...menuData,
  ]

  return (
    <>
      <SchedulingModal isOpen={isScheduleModalOpen} onClose={() => setIsScheduleModalOpen(false)} />
      <S.MenuMobile
        id="menuMobile"
        className={menuOpenState ? 'open-animation' : 'close-animation'}
        open={menuOpenState}
      >
        <MenuItem menuData={menuDataWithAgendar} />
      </S.MenuMobile>
    </>
  )
}

export default MenuContainer
